import Axios from "../../configs/axios.config";

// ==================== DASHBOARD & OVERVIEW ====================

/**
 * Get HR Analytics Dashboard
 * GET /api/reports/dashboard
 */
export const getReportsDashboard = (params) =>
  Axios.get("/reports/dashboard", { params }).then((response) => response.data);

/**
 * Get KPI Summary
 * GET /api/reports/kpi-summary
 */
export const getKPISummary = (params) =>
  Axios.get("/reports/kpi-summary", { params }).then(
    (response) => response.data
  );

// ==================== EXISTING BACKEND APIs ====================

/**
 * Get Manager's Team Attendance Summary
 * GET /api/managers/{manager_id}/team-attendance
 * (Existing Backend API)
 */
export const getManagerTeamAttendance = (managerId, params) =>
  Axios.get(`/managers/${managerId}/team-attendance`, { params }).then(
    (response) => response.data
  );

/**
 * Get Payroll Dashboard KPIs
 * GET /api/payrolls/dashboard
 * (Existing Backend API)
 */
export const getPayrollDashboardKPIs = (params) =>
  Axios.get("/payrolls/dashboard", { params }).then(
    (response) => response.data
  );

// ==================== PAYROLL REPORTS ====================

/**
 * Get Monthly Payroll Cost Report
 * GET /api/reports/payroll-cost
 */
export const getPayrollCostReport = (params) =>
  Axios.get("/reports/payroll-cost", { params }).then(
    (response) => response.data
  );

/**
 * Get Payroll Cost by Department
 * GET /api/reports/payroll-cost/by-department
 */
export const getPayrollCostByDepartment = (params) =>
  Axios.get("/reports/payroll-cost/by-department", { params }).then(
    (response) => response.data
  );

/**
 * Get Payroll Cost Trend
 * GET /api/reports/payroll-cost/trend
 */
export const getPayrollCostTrend = (params) =>
  Axios.get("/reports/payroll-cost/trend", { params }).then(
    (response) => response.data
  );

/**
 * Export Payroll Cost Report
 * GET /api/reports/payroll-cost/export
 */
export const exportPayrollCostReport = (params) =>
  Axios.get("/reports/payroll-cost/export", {
    params,
    responseType: "blob",
  }).then((response) => response.data);

// ==================== ATTENDANCE REPORTS ====================

/**
 * Get Attendance Summary Report
 * GET /api/reports/attendance-summary
 */
export const getAttendanceSummaryReport = (params) =>
  Axios.get("/reports/attendance-summary", { params }).then(
    (response) => response.data
  );

/**
 * Get Attendance by Department
 * GET /api/reports/attendance/by-department
 */
export const getAttendanceByDepartment = (params) =>
  Axios.get("/reports/attendance/by-department", { params }).then(
    (response) => response.data
  );

/**
 * Get Late/Absent Analysis
 * GET /api/reports/attendance/late-absent
 */
export const getLateAbsentAnalysis = (params) =>
  Axios.get("/reports/attendance/late-absent", { params }).then(
    (response) => response.data
  );

/**
 * Get Overtime Report
 * GET /api/reports/attendance/overtime
 */
export const getOvertimeReport = (params) =>
  Axios.get("/reports/attendance/overtime", { params }).then(
    (response) => response.data
  );

/**
 * Export Attendance Report
 * GET /api/reports/attendance/export
 */
export const exportAttendanceReport = (params) =>
  Axios.get("/reports/attendance/export", {
    params,
    responseType: "blob",
  }).then((response) => response.data);

// ==================== LEAVE REPORTS ====================

/**
 * Get Leave Trends Report
 * GET /api/reports/leave-trends
 */
export const getLeaveTrendsReport = (params) =>
  Axios.get("/reports/leave-trends", { params }).then(
    (response) => response.data
  );

/**
 * Get Leave Balance Summary
 * GET /api/reports/leave-balance
 */
export const getLeaveBalanceSummary = (params) =>
  Axios.get("/reports/leave-balance", { params }).then(
    (response) => response.data
  );

/**
 * Get Leave Encashment Liabilities
 * GET /api/reports/leave-encashment
 */
export const getLeaveEncashmentLiabilities = (params) =>
  Axios.get("/reports/leave-encashment", { params }).then(
    (response) => response.data
  );

/**
 * Get Leave by Department
 * GET /api/reports/leave/by-department
 */
export const getLeaveByDepartment = (params) =>
  Axios.get("/reports/leave/by-department", { params }).then(
    (response) => response.data
  );

/**
 * Export Leave Report
 * GET /api/reports/leave/export
 */
export const exportLeaveReport = (params) =>
  Axios.get("/reports/leave/export", {
    params,
    responseType: "blob",
  }).then((response) => response.data);

// ==================== REIMBURSEMENT REPORTS ====================

/**
 * Get Reimbursement Spend Report
 * GET /api/reports/reimbursement-spend
 */
export const getReimbursementSpendReport = (params) =>
  Axios.get("/reports/reimbursement-spend", { params }).then(
    (response) => response.data
  );

/**
 * Get Reimbursement by Category
 * GET /api/reports/reimbursement/by-category
 */
export const getReimbursementByCategory = (params) =>
  Axios.get("/reports/reimbursement/by-category", { params }).then(
    (response) => response.data
  );

/**
 * Get Reimbursement by Department
 * GET /api/reports/reimbursement/by-department
 */
export const getReimbursementByDepartment = (params) =>
  Axios.get("/reports/reimbursement/by-department", { params }).then(
    (response) => response.data
  );

/**
 * Get Reimbursement Trend
 * GET /api/reports/reimbursement/trend
 */
export const getReimbursementTrend = (params) =>
  Axios.get("/reports/reimbursement/trend", { params }).then(
    (response) => response.data
  );

/**
 * Export Reimbursement Report
 * GET /api/reports/reimbursement/export
 */
export const exportReimbursementReport = (params) =>
  Axios.get("/reports/reimbursement/export", {
    params,
    responseType: "blob",
  }).then((response) => response.data);

// ==================== HEADCOUNT & ATTRITION REPORTS ====================

/**
 * Get Headcount Report
 * GET /api/reports/headcount
 */
export const getHeadcountReport = (params) =>
  Axios.get("/reports/headcount", { params }).then((response) => response.data);

/**
 * Get Headcount by Department
 * GET /api/reports/headcount/by-department
 */
export const getHeadcountByDepartment = (params) =>
  Axios.get("/reports/headcount/by-department", { params }).then(
    (response) => response.data
  );

/**
 * Get Headcount Trend
 * GET /api/reports/headcount/trend
 */
export const getHeadcountTrend = (params) =>
  Axios.get("/reports/headcount/trend", { params }).then(
    (response) => response.data
  );

/**
 * Get Attrition Report
 * GET /api/reports/attrition
 */
export const getAttritionReport = (params) =>
  Axios.get("/reports/attrition", { params }).then((response) => response.data);

/**
 * Get Attrition Rate
 * GET /api/reports/attrition/rate
 */
export const getAttritionRate = (params) =>
  Axios.get("/reports/attrition/rate", { params }).then(
    (response) => response.data
  );

/**
 * Get New Joiners Report
 * GET /api/reports/new-joiners
 */
export const getNewJoinersReport = (params) =>
  Axios.get("/reports/new-joiners", { params }).then(
    (response) => response.data
  );

/**
 * Export Headcount Report
 * GET /api/reports/headcount/export
 */
export const exportHeadcountReport = (params) =>
  Axios.get("/reports/headcount/export", {
    params,
    responseType: "blob",
  }).then((response) => response.data);

// ==================== REPORT BUILDER ====================

/**
 * Get Available Report Fields
 * GET /api/reports/builder/fields
 */
export const getReportBuilderFields = (reportType) =>
  Axios.get(`/reports/builder/fields`, { params: { report_type: reportType } }).then(
    (response) => response.data
  );

/**
 * Generate Custom Report
 * POST /api/reports/builder/generate
 */
export const generateCustomReport = (data) =>
  Axios.post("/reports/builder/generate", data).then(
    (response) => response.data
  );

/**
 * Save Custom Report Template
 * POST /api/reports/builder/save-template
 */
export const saveReportTemplate = (data) =>
  Axios.post("/reports/builder/save-template", data).then(
    (response) => response.data
  );

/**
 * Get Saved Report Templates
 * GET /api/reports/builder/templates
 */
export const getSavedReportTemplates = () =>
  Axios.get("/reports/builder/templates").then((response) => response.data);

/**
 * Delete Report Template
 * DELETE /api/reports/builder/templates/{id}
 */
export const deleteReportTemplate = (id) =>
  Axios.delete(`/reports/builder/templates/${id}`).then(
    (response) => response.data
  );

/**
 * Export Custom Report
 * POST /api/reports/builder/export
 */
export const exportCustomReport = (data) =>
  Axios.post("/reports/builder/export", data, {
    responseType: "blob",
  }).then((response) => response.data);

// ==================== FILTERS & UTILITIES ====================

/**
 * Get Departments List (for filters)
 * GET /api/departments/list
 */
export const getDepartmentsList = () =>
  Axios.get("/departments/list").then((response) => response.data);

/**
 * Get Designations List (for filters)
 * GET /api/designations/list
 */
export const getDesignationsList = () =>
  Axios.get("/designations/list").then((response) => response.data);

/**
 * Get Report Export History
 * GET /api/reports/export-history
 */
export const getExportHistory = (params) =>
  Axios.get("/reports/export-history", { params }).then(
    (response) => response.data
  );

/**
 * Download Report from History
 * GET /api/reports/export-history/{id}/download
 */
export const downloadReportFromHistory = (id) =>
  Axios.get(`/reports/export-history/${id}/download`, {
    responseType: "blob",
  }).then((response) => response.data);

// ==================== SCHEDULED REPORTS ====================

/**
 * Schedule Report
 * POST /api/reports/schedule
 */
export const scheduleReport = (data) =>
  Axios.post("/reports/schedule", data).then((response) => response.data);

/**
 * Get Scheduled Reports
 * GET /api/reports/schedule
 */
export const getScheduledReports = () =>
  Axios.get("/reports/schedule").then((response) => response.data);

/**
 * Update Scheduled Report
 * PUT /api/reports/schedule/{id}
 */
export const updateScheduledReport = (id, data) =>
  Axios.put(`/reports/schedule/${id}`, data).then((response) => response.data);

/**
 * Delete Scheduled Report
 * DELETE /api/reports/schedule/{id}
 */
export const deleteScheduledReport = (id) =>
  Axios.delete(`/reports/schedule/${id}`).then((response) => response.data);

